import { Box, Dialog, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CompanySimilaritySearch } from '../company-similarity-search';

export const Wrapper = styled(Box)``;

export const SearchDialog = styled(Dialog)<{ hasError?: boolean }>``;

export const CompanySearch = styled(CompanySimilaritySearch)`
  .top {
    border-radius: ${(p) => p.theme.spacing(1)};
  }
`;

export const Container = styled(Stack)`
  background: linear-gradient(0deg, #fff 0%, #f1f4ff 100%);
  padding: ${(p) => p.theme.spacing(2)};
`;
